import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=1498be52&scoped=true"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"
import style0 from "./TemplateDefault.vue?vue&type=style&index=0&id=1498be52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1498be52",
  null
  
)

export default component.exports